import { ReactNode, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Tooltip.css';

type Props = {
  ToolTipString: string | undefined;
  children: ReactNode;
};
function SectionTreeTooltip({ ToolTipString, children }: Props) {
  const { t } = useTranslation();

  const ref = useRef<HTMLDivElement>(null);

  const [show, setShow] = useState(false);
  return (
    <div className="tooltip-container">
      <div ref={ref} onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
        {children}
      </div>
      {show && (
        <div className="bottom">
          <div>{t(ToolTipString ?? '')}</div>
        </div>
      )}
    </div>
  );
}
export { SectionTreeTooltip };
